import { createContext } from 'react'

import type { AdminUser } from '@/services/admin/types'

export type AuthContextValue = {
  token: string | null
  user: AdminUser | null
  isAuthenticated: boolean
  /** True while initial /me fetch runs (when a token exists). */
  userLoading: boolean
  signIn: (token: string, user?: AdminUser) => void
  refreshUser: () => Promise<void>
  signOut: () => void
}

export const AuthContext = createContext<AuthContextValue | null>(null)
